import React from 'react';

import useMartyContext from 'hooks/useMartyContext';
import UtilityDottedFilterMediumIcon from 'tailwind/components/Icons/UtilityDottedFilterMediumIcon';

interface FiltersButtonProps {
  onToggleFacetsContainer: () => void;
  multiCount?: number;
}

export const FiltersButton = ({ onToggleFacetsContainer, multiCount }: FiltersButtonProps) => {
  const { testId } = useMartyContext();
  return (
    <button
      type="button"
      className="body-xs-subtle flex h-10 w-auto items-center justify-center gap-2 rounded-sm border border-gray-200 px-4 max-sm:w-full"
      data-test-id={testId('filterButton')}
      onClick={onToggleFacetsContainer}
    >
      <UtilityDottedFilterMediumIcon size={24} />
      Filters {multiCount ? `(${multiCount})` : ''}
    </button>
  );
};
